import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={896}
        height={815}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 896 815`}
        {...props}
    >
        <g filter="url(#a)">
            <path
                opacity={0.1}
                d="M314 580c164.581 0 298-128.494 298-287S478.581 6 314 6 16 134.494 16 293s133.419 287 298 287Z"
                fill="#F72585"
            />
        </g>
        <g filter="url(#b)">
            <path
                opacity={0.1}
                d="M589 695c164.581 0 298-128.494 298-287S753.581 121 589 121 291 249.494 291 408s133.419 287 298 287Z"
                fill="#480CA8"
            />
        </g>
        <g filter="url(#c)">
            <path
                opacity={0.1}
                d="M307 803c164.581 0 298-128.494 298-287S471.581 229 307 229 9 357.494 9 516s133.419 287 298 287Z"
                fill="#4CC9F0"
            />
        </g>
        <defs>
            <filter
                id="a"
                x={10}
                y={3}
                width={608}
                height={586}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={3} />
                <feGaussianBlur stdDeviation={3} />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_172" />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_172"
                    result="shape"
                />
            </filter>
            <filter
                id="b"
                x={285}
                y={118}
                width={608}
                height={586}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={3} />
                <feGaussianBlur stdDeviation={3} />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_172" />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_172"
                    result="shape"
                />
            </filter>
            <filter
                id="c"
                x={3}
                y={226}
                width={608}
                height={586}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={3} />
                <feGaussianBlur stdDeviation={3} />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0" />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3_172" />
                <feBlend
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3_172"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
)

export default SvgComponent
